import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLUmbrellaCoverage({ data, getFormattedCurrency, show }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th>{translator(messages.Coverage)}</th>
                    <th>{translator(messages.Limits)}</th>
                    <th>{translator(messages.Premium)}</th>
                </tr>
            </thead>
        );
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <hr className="vertical-spacing-40" />
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.UmbrellaCoverage)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {data.map((coverage) => {
                            return (
                                <tr>
                                    <td><strong>{coverage.name}</strong></td>
                                    <td><strong>{coverage.terms[0].chosenTermValue}</strong></td>
                                    <td>{getFormattedCurrency(coverage.amount)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLUmbrellaCoverage.propTypes = {
    data: PropTypes.shape([]),
    getFormattedCurrency: PropTypes.func.isRequired,
    show: PropTypes.bool
};
MLUmbrellaCoverage.defaultProps = {
    data: [],
    show: false
};
export default MLUmbrellaCoverage;
